import { CustomerTypeEnum, UserContext } from '../gen/models'

/**
 * #7701/#7907 — whether this principal gets the SUPPLIER experience of the shared shell: a supplier-typed
 * customer and not an admin. Flag-free by design — it is #7701's nav-rule population, and a flag-OFF
 * supplier never reaches the shell (the provider holds, then ejects). It includes an admin cloaked into a
 * supplier customer: cloaking clears `isAdmin` server-side (`auth.service.ts:323`/`:330`).
 *
 * ⚠️ The `!isAdmin` term is load-bearing: `adminNavSections` offers admins Reports inside a family
 * `NonSupplierGuardedRoute` closes, so dropping it would lock a supplier-typed admin out of their own nav
 * destination (locked by NonSupplierGuardedRoute.test.tsx G4).
 *
 * This is the shell-rule predicate of record — the nav's Home item, the `/` element, the hospital-family
 * guard and Home's hospital sections all read it, so nav visibility and route reachability cannot drift
 * (react-conventions §32.1). It is NOT `hasSupplierPortalAccess`: that one answers "who gets the portal",
 * carries the flag term, and excludes the non-cloaked admin by `isAdmin === true` rather than by this term.
 */
export const isNonAdminSupplier = (me: UserContext | undefined): boolean => {
  const isSupplier = me?.user.customer.type === CustomerTypeEnum.Supplier
  return isSupplier && !me?.isAdmin
}
